<template>
<Header />
  <section class="hero is-link is-fullheight-with-navbar">
    <div class="hero-body">
      <div class="container has-text-centered">

      </div>
    </div>
  </section>
  <router-view></router-view>
<Footer />
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "NotFound",
  components: {
    Header,
    Footer,
  },
};
</script>